import { render } from "./ColloquePage.vue?vue&type=template&id=428639ae"
import script from "./ColloquePage.vue?vue&type=script&lang=js"
export * from "./ColloquePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__